import { Stack } from 'expo-router';
import { Platform, useWindowDimensions } from 'react-native';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

const MenuIndexStackHeader = getScreenTitleHeader();

export default function TabMenuWebLayout() {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === 'web' && width >= 768;

  return (
    <Stack>
      <Stack.Screen
        name="(menu)/index"
        options={{
          header: props => <MenuIndexStackHeader {...props} />,
          headerShown: !isDesktopWeb,
          title: 'Menu',
        }}
      />
    </Stack>
  );
}
